module.exports = __webpack_public_path__ + "img/unearth-malee_banner.44540188.jpg";